import { Button, DatePicker, Form, Space, Switch } from 'antd';
import {
  Agendado,
  Dados,
  Finalizado,
  Icons,
  Info,
  LabelFormInfo,
  ShowDate,
  StatusIcons,
} from './styles';
import { CALENDAR_LOCALE } from 'utils/calendar-locale';
import { useDispatch, useSelector } from 'react-redux';
import iconentrega from 'assets/img/entrega.svg';
import iconcoleta from 'assets/img/coleta.svg';
import { PrinterOutlined } from '@ant-design/icons';
import saveAs from 'file-saver';
import { SKW_PREFIX } from 'utils/constants';
import api from 'service/api';
import { ApplicationState } from 'store';
import { filterAgendamentos } from '../../../../../../store/ducks/consultaAgendamentos/actions';
import { useState } from 'react';
import moment from 'moment';

interface Props {
  handleStateSwitch: (
    newStateAgendado: boolean,
    newStateFinalizado: boolean,
    newStateEntrega: boolean,
    newStateColeta: boolean
  ) => void;
}

export const InfosHeader: React.FC<Props> = ({ handleStateSwitch }) => {
  const dispatch = useDispatch();
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const total = useSelector((state: ApplicationState) => state.ConsultaAgendamentos.total);
  const filter = useSelector((state: ApplicationState) => state.ConsultaAgendamentos.filter);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const [loading, setLoading] = useState<boolean>(false);
  const [stateEntrega, setStateEntrega] = useState<boolean>(true);
  const [stateColeta, setStateColeta] = useState<boolean>(true);
  const [stateAgendado, setStateAgendado] = useState<boolean>(true);
  const [stateFinalizado, setStateFinalizado] = useState<boolean>(true);
  const [date, setDate] = useState<any>(moment().format());

  const onFilter = (values: any) => {
    if (values) {
      setDate(values);
      dispatch(filterAgendamentos({ dtAgendamento: moment(values).format() }));
      return;
    }
    setDate(moment().format());
    dispatch(filterAgendamentos({ dtAgendamento: moment().format() }));
  };

  const imprimeRelatorio = () => {
    setLoading(true);
    api
      .post(
        `/call?serviceName=${SKW_PREFIX}imprimeResumoAgendamentos&token=${token}`,
        {
          dtAgendamento: moment(filter?.dtAgendamento).format(),
          codCdd: cddAtivo?.codCdd,
          parceiros: inscricaoAtiva,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        saveAs(blob, 'relatorio tipos de carroceria.pdf');
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const totalAgend = (function (
    totalAgendamentos = 0,
    totalFinalizado = 0,
    totalPendente = 0,
    totalColeta = 0,
    totalEntrega = 0,
    totalPendenteEntrega = 0,
    totalPendenteColeta = 0,
    totalFinalizadoEntrega = 0,
    totalFinalizadoColeta = 0
  ) {
    //TODOS TRUE
    if (stateColeta && stateEntrega && stateAgendado && stateFinalizado) {
      return {
        totalAgendamentos,
        totalFinalizado,
        totalPendente,
      };
    } //TODOS FALSE
    else if (
      stateColeta === false &&
      stateEntrega === false &&
      stateAgendado === false &&
      stateFinalizado === false
    ) {
      return {
        totalAgendamentos: 0,
        totalFinalizado: 0,
        totalPendente: 0,
      };
    } // UM DOA LADOS FALSE
    else if (
      (stateColeta === false && stateEntrega === false) ||
      (stateAgendado === false && stateFinalizado === false)
    ) {
      return {
        totalAgendamentos: 0,
        totalFinalizado: 0,
        totalPendente: 0,
      };
    } // TODAS AS ENTREGAS
    else if (stateColeta === false && stateEntrega && stateAgendado && stateFinalizado) {
      return {
        totalAgendamentos: totalEntrega,
        totalFinalizado: totalFinalizado - totalFinalizadoColeta,
        totalPendente: totalPendente - totalPendenteColeta,
      };
    } // TODAS AS COLETAS
    else if (stateColeta && stateEntrega === false && stateAgendado && stateFinalizado) {
      return {
        totalAgendamentos: totalColeta,
        totalFinalizado: totalFinalizado - totalFinalizadoEntrega,
        totalPendente: totalPendente - totalPendenteEntrega,
      };
    } //COLETAS E ENTREGAS FINALIZADOS
    else if (stateColeta && stateEntrega && stateAgendado === false && stateFinalizado) {
      return {
        totalAgendamentos: totalFinalizado,
        totalFinalizado: totalFinalizado,
        totalPendente: 0,
      };
    } // COLETAS E ENTREGAS PENDENTES
    else if (stateColeta && stateEntrega && stateAgendado && stateFinalizado === false) {
      return {
        totalAgendamentos: totalPendente,
        totalFinalizado: 0,
        totalPendente: totalPendente,
      };
    } // ENTREGAS FINALIZADAS
    else if (stateColeta === false && stateEntrega && stateAgendado === false && stateFinalizado) {
      return {
        totalAgendamentos: totalFinalizadoEntrega,
        totalFinalizado: totalFinalizadoEntrega,
        totalPendente: 0,
      };
    } // ENTREGA PENDENTE
    else if (stateColeta === false && stateEntrega && stateAgendado && stateFinalizado === false) {
      return {
        totalAgendamentos: totalPendenteEntrega,
        totalFinalizado: 0,
        totalPendente: totalPendenteEntrega,
      };
    } // COLETA FINALIZADA
    else if (stateColeta && stateEntrega === false && stateAgendado === false && stateFinalizado) {
      return {
        totalAgendamentos: totalFinalizadoColeta,
        totalFinalizado: totalFinalizadoColeta,
        totalPendente: 0,
      };
    } // COLETA PENDENTE
    else if (stateColeta && stateEntrega === false && stateAgendado && stateFinalizado === false) {
      return {
        totalAgendamentos: totalPendenteColeta,
        totalFinalizado: 0,
        totalPendente: totalPendenteColeta,
      };
    } else {
      return {
        totalAgendamentos: 0,
        totalFinalizado: 0,
        totalPendente: 0,
      };
    }
  })(
    total?.total,
    total?.totExpedido,
    total?.totAgendado,
    total?.totColeta,
    total?.totEntrega,
    total?.tAgeEntrega,
    total?.tAgeColeta,
    total?.tExpEntrega,
    total?.tExpColeta
  );

  return (
    <Info>
      <div className="infoContainer">
        <Form className="formMobile">
          <LabelFormInfo>Selecione a data</LabelFormInfo>
          <Form.Item name="dtAgendamento">
            <DatePicker
              data-cy="dtAgendamento"
              onChange={(e) => onFilter(e)}
              locale={CALENDAR_LOCALE}
              format="DD/MM/YYYY"
              style={{ width: '240px' }}
              inputReadOnly
            />
          </Form.Item>
        </Form>

        <Icons>
          Tipo de atendimento
          <div>
            <div>
              <Space>
                <Switch
                  size="small"
                  defaultChecked
                  onChange={(e) => {
                    setStateColeta(e);
                    handleStateSwitch(stateAgendado, stateFinalizado, stateEntrega, e);
                  }}
                  className="removeMobile"
                />
                <img src={iconcoleta} alt="icone de coleta" /> Coleta{' '}
              </Space>{' '}
            </div>
            <div>
              <Space>
                <Switch
                  size="small"
                  defaultChecked
                  onChange={(e) => {
                    setStateEntrega(e);

                    handleStateSwitch(stateAgendado, stateFinalizado, e, stateColeta);
                  }}
                  className="removeMobile"
                />
                <img src={iconentrega} alt="icone de entrega" /> Entrega{' '}
              </Space>{' '}
            </div>
          </div>
        </Icons>

        <StatusIcons>
          Status do atendimento
          <Space>
            <div style={{ display: 'flex' }}>
              <Space>
                <Switch
                  size="small"
                  defaultChecked
                  onChange={(e) => {
                    setStateAgendado(e);
                    handleStateSwitch(e, stateFinalizado, stateEntrega, stateColeta);
                  }}
                />
                <Agendado />
              </Space>{' '}
              <span>Pendente</span>
            </div>
            <div>
              <Space>
                <Switch
                  size="small"
                  defaultChecked
                  onChange={(e) => {
                    setStateFinalizado(e);
                    handleStateSwitch(stateAgendado, e, stateEntrega, stateColeta);
                  }}
                />
                <Finalizado />
              </Space>{' '}
              <span>Finalizado</span>
            </div>
          </Space>
        </StatusIcons>
      </div>

      <Dados>
        <div>
          <div className="caixa">
            <div className="numero">{totalAgend?.totalAgendamentos}</div>
            <div className="texto">Agendamentos</div>
          </div>
          <div className="caixa">
            <div className="numero">{totalAgend?.totalFinalizado}</div>
            <div className="texto">Finalizado</div>
          </div>
          <div className="caixa">
            <div className="numero">{totalAgend?.totalPendente}</div>
            <div className="texto">Pendente</div>
          </div>
          <div className="caixa">
            <div className="numero">{total?.totFerro ?? 0}</div>
            <div className="texto">Assoalho de ferro</div>
          </div>
          <div className="caixa">
            <div className="numero">{total?.totMadeira ?? 0}</div>
            <div className="texto">Assoalho de madeira</div>
          </div>
        </div>
        <div className="relatorio">
          <Button
            type="primary"
            icon={<PrinterOutlined style={{ color: '#fff' }} />}
            onClick={() => imprimeRelatorio()}
            loading={loading}
          >
            Relatório tipos de carroceria
          </Button>
        </div>
      </Dados>

      <ShowDate>{moment(date).format('LL')}</ShowDate>
    </Info>
  );
};
